let isTouchCache: boolean | undefined = undefined;
import cloneDeep from 'lodash/cloneDeep';

/**
 * Test if browser is touch screen
 *
 * @returns boolean
 */
export function isTouch(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  if (isTouchCache !== undefined) {
    return isTouchCache;
  }
  // has touch and does not have mouse (pointer: fine)
  isTouchCache =
    (window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(pointer: coarse)').matches ||
      navigator.maxTouchPoints > 0) &&
    !window.matchMedia('(pointer: fine)').matches;
  return isTouchCache;
}

/**
 * Cleans href or src value so it only allows http and mailto
 *
 * @param linkOrSrc
 * @returns
 */
export function cleanLinkSrc(linkOrSrc: string | undefined) {
  if (!/^(http|https|mailto):\/\//.test(linkOrSrc ?? '')) {
    return '';
  }
  return linkOrSrc;
}

export function isAndroid() {
  return navigator.userAgent.toLowerCase().indexOf('android') > -1;
}

export function cloneObject(obj) {
  if (typeof structuredClone === 'function') {
    return structuredClone(obj);
  } else {
    return cloneDeep(obj);
  }
}
